export default __webpack_public_path__ + "static/media/hamburger_dark.e813dbae.svg";